import { Box } from "@mui/material"
import { type ColumnSort, type OnChangeFn, type SortingState, getCoreRowModel } from "@tanstack/react-table"
import React, { type FC, type Ref } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import { expandedCellStyles } from "@/components/Tables/Aeros/shared"
import type { Category } from "@/graphql/codegen/graphql"
import { useProductCategoriesColumns } from "@/screens/ManageProducts/components/ProductCategories/hooks/useProductCategoriesColumns"

interface ProductCategoriesTableProps {
  data: Category[]
  fetching: boolean
  onScrollHandler: () => void
  tableContainerRef?: Ref<HTMLDivElement>
  onHandleSortingChange: (updaterFn: (state: SortingState) => SortingState) => void
  sorting: ColumnSort[]
  onOpenEditCategoryDialog: (original: Category) => void
  error?: Error
}

const ProductCategoriesTable: FC<ProductCategoriesTableProps> = ({
  data,
  error,
  onHandleSortingChange,
  sorting,
  tableContainerRef,
  fetching,
  onScrollHandler,
  onOpenEditCategoryDialog,
}) => {
  const columns = useProductCategoriesColumns({
    onOpenEditCategoryDialog,
  })
  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable
        error={error}
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data,
            columns,
            state: {
              sorting,
              isLoading: fetching,
            },
            manualSorting: true,
            enableSorting: true,
            enableMultiSort: false,
            enableSortingRemoval: false,
            getCoreRowModel: getCoreRowModel(),
            onSortingChange: onHandleSortingChange as OnChangeFn<SortingState>,
          },
        }}
        slotProps={{
          container: {
            ref: tableContainerRef,
            onScroll: onScrollHandler,
          },
          bodyCellExpanded: { className: "bg-primary-100" },
          expandedCell: expandedCellStyles,
          bodyRow: {
            className: "hover:bg-primary-100 cursor-pointer",
          },
        }}
        noDataMessage='No product categories found'
      />
    </Box>
  )
}

export default ProductCategoriesTable
